import { render, staticRenderFns } from "./NotificationsTemplate.vue?vue&type=template&id=7e16aa46&scoped=true&"
import script from "./NotificationsTemplate.vue?vue&type=script&lang=js&"
export * from "./NotificationsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTemplate.vue?vue&type=style&index=0&id=7e16aa46&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16aa46",
  null
  
)

export default component.exports